import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'firebaseui/dist/firebaseui.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/css/fontawesome-pro-regular.css';
import './assets/css/fontawesome-pro-core.css';
import './index.css';

import App from './components/App';
import createStore from './redux/store';
import registerServiceWorker from './registerServiceWorker';

const history = createHistory();
const store = createStore(history);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js